import { Component, OnInit, OnDestroy } from '@angular/core';
import { PwaService } from '../../../core/services/pwa.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-offline-indicator',
  templateUrl: './offline-indicator.component.html',
  styleUrls: ['./offline-indicator.component.scss']
})
export class OfflineIndicatorComponent implements OnInit, OnDestroy {
  isOnline = true;
  showIndicator = false;
  private destroy$ = new Subject<void>();

  constructor(private pwaService: PwaService) {}

  ngOnInit(): void {
    this.pwaService.isOnline$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOnline => {
        this.isOnline = isOnline;
        this.showIndicator = !isOnline;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dismiss(): void {
    this.showIndicator = false;
  }
}











